module.exports = __webpack_public_path__ + "img/nexium_24hr_capsules.c3cdacfb.png";